const VariaveisGlobais = {
    idClinica: null,
    token: null,
    usuario: null,
    idEmpresa: null,
    idUsuario: null
};

export default VariaveisGlobais;